import CommonForm from './CommonForm';

export default CommonForm;
